import { tsValidateResult, tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocParamType_Dynamic } from './types.js';
import { smartDocExternalParamType_API, smartDocExternalParamType_FreeText, smartDocExternalParamType_NavigationResponse, smartDocExternalParamType_Order, smartDocParamType_External } from '../external/index.js';
import { Validator_SmartDocParamResolver_NavigationResponse, Validator_SmartDocParamResolver_Order, Validator_SmartDocParamResolver_WorkingDiagnosis } from '../../smart-doc-param-resolver/index.js';
import { Validator_SmartDocParamCondition_DispositionType, Validator_SmartDocParamCondition_WorkingDiagnosis } from '../../smart-doc-param-condition/index.js';
import { smartDocExternalParam_ParamKey_DispositionType, smartDocExternalParam_ParamKey_WorkingDiagnosisId } from '../external/param-key.js';
const Validator_SmartDocDynamicParam_Base = {
    key: tsValidateString(),
    type: tsValidateValue([smartDocParamType_Dynamic]),
    externalKey: tsValidateString(),
};
const Validator_SmartDocDynamicParam_FreeText = Validator_SmartDocDynamicParam_Base;
const Validator_SmartDocDynamicParam_NavigationResponse = {
    ...Validator_SmartDocDynamicParam_Base,
    resolver: Validator_SmartDocParamResolver_NavigationResponse,
};
const Validator_SmartDocDynamicParam_Order = {
    ...Validator_SmartDocDynamicParam_Base,
    resolver: Validator_SmartDocParamResolver_Order,
};
const Validator_SmartDocDynamicParam_WorkingDiagnosis = {
    ...Validator_SmartDocDynamicParam_Base,
    resolver: Validator_SmartDocParamResolver_WorkingDiagnosis,
    condition: Validator_SmartDocParamCondition_WorkingDiagnosis,
};
const Validator_SmartDocDynamicParam_DispositionType = {
    ...Validator_SmartDocDynamicParam_Base,
    condition: Validator_SmartDocParamCondition_DispositionType,
};
export const Validator_SmartDocDynamicParam = (param, parent) => {
    if (!param)
        return 'Did not receive dynamic param to validate';
    //If the log template parent isn't passed
    if (!parent)
        return 'Can not validate dynamic log template parameter without the log template';
    //Validate that an external parameter exists with a key matching the param.externalKey
    const externalParam = parent.find(_param => _param.type === smartDocParamType_External && _param.key === param.externalKey);
    if (!externalParam)
        return param.externalKey ? { externalKey: 'External key not connected to an actual param' } : { externalKey: 'Missing mandatory value' };
    switch (externalParam.subType) {
        case smartDocExternalParamType_FreeText:
            return tsValidateResult(param, Validator_SmartDocDynamicParam_FreeText);
        case smartDocExternalParamType_NavigationResponse:
            return tsValidateResult(param, Validator_SmartDocDynamicParam_NavigationResponse);
        case smartDocExternalParamType_Order:
            return tsValidateResult(param, Validator_SmartDocDynamicParam_Order);
        case smartDocExternalParamType_API:
            switch (externalParam.paramKey) {
                case smartDocExternalParam_ParamKey_WorkingDiagnosisId:
                    return tsValidateResult(param, Validator_SmartDocDynamicParam_WorkingDiagnosis);
                case smartDocExternalParam_ParamKey_DispositionType:
                    return tsValidateResult(param, Validator_SmartDocDynamicParam_DispositionType);
                default:
                    return externalParam.paramKey
                        ? { externalKey: 'Missing paramKey on API external param' }
                        : { externalKey: `Unknown API external param paramKey: ${externalParam.paramKey}` };
            }
        default:
            //@ts-ignore
            return externalParam.subType ? { externalKey: 'External param missing field subType' } : { externalKey: `Missing implementation for external param subType ${externalParam.subType}` };
    }
};
//# sourceMappingURL=validation.js.map